// ═══════════════════════════════════════════════════════════════════
//  modules/wiki/WikiPanel.js
//  WikiPanel
// ═══════════════════════════════════════════════════════════════════

import { useEffect, useRef, useState } from "react";
import { THEME } from "../../socle/theme";
import { wikiApi } from "./api";
import { wCat } from "./constantes";
import { wGhostSm, wLbl } from "./styles";

// ═══════════════ Encart Dashboard (lot 2) ═══════════════
//  À utiliser dans DashboardHome :  <WikiPanel token={token} onNavigate={onNavigate} />
export function WikiPanel({ token, onNavigate }) {
  const api = useRef(wikiApi(token)).current;
  const [d, setD] = useState(null);

  useEffect(() => {
    api.dashboard().then(setD).catch(() => setD(null));
    const id = setInterval(() => api.dashboard().then(setD).catch(() => {}), 120000);
    return () => clearInterval(id);
  }, [api]);

  const aller = () => onNavigate && onNavigate("wiki");
  const ligne = (icone, texte, detail, cle) => (
    <div key={cle} onClick={aller}
      style={{ display: "flex", gap: 8, alignItems: "center", padding: "6px 0", borderBottom: `1px solid ${THEME.border}`, cursor: "pointer", fontSize: 12.5 }}>
      <span>{icone}</span>
      <span style={{ color: THEME.text, flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{texte}</span>
      <span style={{ color: THEME.textDim, fontSize: 11, whiteSpace: "nowrap" }}>{detail}</span>
    </div>
  );

  return (
    <div style={{ background: THEME.panel, border: `1px solid ${THEME.border}`, borderRadius: 14, padding: 18, marginBottom: 16 }}>
      <div style={{ display: "flex", alignItems: "center", marginBottom: 14 }}>
        <div style={{ color: THEME.textMuted, fontSize: 12, fontWeight: 700, letterSpacing: 0.6, textTransform: "uppercase" }}>📚 Wiki Staff</div>
        <button onClick={aller} style={{ ...wGhostSm, marginLeft: "auto" }}>Ouvrir le wiki →</button>
      </div>

      {!d && <div style={{ color: THEME.textDim, fontSize: 13 }}>Lecture…</div>}

      {d && (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: 18 }}>
          <div>
            <div style={{ ...wLbl, marginBottom: 6, color: THEME.amber }}>📖 À lire pour toi ({d.aLire.length})</div>
            {d.aLire.length === 0
              ? <div style={{ color: THEME.emerald, fontSize: 12.5 }}>✓ tu es à jour</div>
              : d.aLire.map((p) => ligne(wCat(p.categorie).icone, p.titre, `v${p.version}`, `l${p.id}`))}
          </div>
          <div>
            <div style={{ ...wLbl, marginBottom: 6, color: THEME.purple }}>📝 Brouillons en attente ({d.brouillons.length})</div>
            {d.brouillons.length === 0
              ? <div style={{ color: THEME.textDim, fontSize: 12.5 }}>aucun</div>
              : d.brouillons.map((p) => ligne(p.ia_assiste ? "🤖" : "📝", p.titre, p.auteur || "—", `b${p.id}`))}
          </div>
          <div>
            <div style={{ ...wLbl, marginBottom: 6 }}>🕸️ À rafraîchir ({d.aRelire.length})</div>
            {d.aRelire.length === 0
              ? <div style={{ color: THEME.emerald, fontSize: 12.5 }}>✓ rien de poussiéreux</div>
              : d.aRelire.map((p) => ligne(wCat(p.categorie).icone, p.titre,
                  `${Math.floor((Date.now() - new Date(p.updated_at)) / 86400000)} j`, `r${p.id}`))}
          </div>
        </div>
      )}

      {d && <div style={{ color: THEME.textDim, fontSize: 11, marginTop: 12 }}>{d.total} page(s) publiée(s) au wiki.</div>}
    </div>
  );
}
